<script setup lang="ts">

const containerRef = ref(null)
const slides = ref(Array.from({ length: 10 }))

const swiper = useSwiper(containerRef);

const testimony = ref({
    author: '',
    testimony: '',
    highlight: '',
})

const testimonials = ref([
  {
    author: 'Willian Moreira',
    testimony: `Eu conheci a casa no ano de 2022, ano que estava passando por várias situações difíceis, desempregado, muitas crises de pânico e ansiedade. Eu sempre soube que era  médium e que precisava me desenvolver, mas sempre hesitava em aceitar. Como muitos, acreditava que havia um momento certo para se entregar a esse caminho, mas o tempo me ensinou que, na verdade, o que se espera é a aceitação do que somos, da missão que trazemos e foi ai que eu entendi que a espiritualidade não esperava o momento certo e sim que sejamos verdadeiros conosco. \n
A busca por uma religião que me preenchesse e que oferecesse respostas me levou a mudar várias vezes, mas nada parecia ser capaz de trazer o alívio que eu tanto desejava. Foi então que, guiado por uma sensação de chamado, eu encontrei o Terreiro de Umbanda Vó Rita das Almas. Nesse lugar de luz, eu me senti acolhido, amado, e logo percebi que ali, entre os guias e os Orixás, minha vida estava se transformando. \n
Meu primeiro contato foi através da assistência, e logo eu senti a diferença, uma energia transformadora que me envolvia a cada visita. Os guias e os Orixás começaram a imantar minha vida com luz e Axé, antes mesmo de eu iniciar o processo de desenvolvimento mediúnico. E, assim, eu  dei o primeiro passo no caminho do autoconhecimento espiritual.\n
Hoje, faço parte dessa casa de fé, fui muito bem acolhido pelos Pais e Mães e todos os irmãos e conheço a importância de cada passo dado nesse meu processo de evolução. Através da aceitação, eu encontrei não só o alívio para minhas angústias e crises, mas também o propósito de ajudar os outros, levando o ensinamento de que a espiritualidade está sempre presente, aguardando nosso reconhecimento e entrega.\n
E nesse tempo eu larguei vícios, sou uma pessoa mais calma, já não tenho mais crises, arrumei um bom trabalho, me mudei para uma casa melhor e com um passo de cada vez, estou caminhando e aprendendo.\m
E, ao olhar para trás, eu percebo que a busca por respostas nunca foi em vão; cada passo, cada experiência, faz  parte de minha trajetória rumo ao encontro de mim mesmo.\n
Sou grato ao terreiro Vó Rita das Almas por todo acolhimento, uma casa de muita luz e Axé, que estará sempre à disposição de quem se permite acreditar na força da espiritualidade.\n
É pra quem tem fé.\nAxé.`,
    highlight: `Sou grato ao terreiro Vó Rita das Almas por todo acolhimento, uma casa de muita luz e Axé, que estará sempre à disposição de quem se permite acreditar na força da espiritualidade. É pra quem tem fé`,
  },
  {
    author: 'Raissa Monteiro',
    testimony: `O Terreiro de Umbanda Vó Rita das Almas me acolheu em um momento em que eu estava perdida, sem rumo, enfrentando crises de ansiedade, adoecendo por dentro e com poucas expectativas sobre a minha própria vida.

Cumprindo uma promessa feita ao Pai Noé de Xangô, visitei o Terreiro por três dias para decidir se era aquilo que eu queria. Mas foi muito mais do que eu queria: era o que eu precisava. Não apenas pela busca de melhora, mas pelo amor que senti pela casa, pelos pais e seus sermões, e pela transformação que comecei a perceber em mim mesma.

A mudança é lenta e, muitas vezes, dolorosa, mas é também profundamente necessária. Aprendi a cultivar mais paciência com as pessoas ao meu redor, comigo mesma e com o meu processo. A Umbanda é para aqueles que têm amor e empatia para acompanhar esse percurso. É como plantar uma semente: você a observa crescer, mesmo quando parece que nada mudou. Mas ela está lá, crescendo. E, quando você menos espera — depois de muito cuidado, rega e aprendizados com os erros —, percebe as belas flores de uma árvore forte e cheia de frutos.

Fui abraçada, ouvida e compreendida pelos pais, mães e irmãos da casa, mesmo quando achava que ninguém estaria lá por mim. Hoje, olhando para trás, não me arrependo de ter seguido os conselhos e os ensinamentos de quem me acolheu de coração aberto.

Eu estava machucada, sem rumo ou orientação. Hoje, posso dizer que vejo o mundo com mais leveza e clareza.`,
    highlight: 'Fui abraçada, ouvida e compreendida pelos pais, mães e irmãos da casa, mesmo quando achava que ninguém estaria lá por mim. Hoje, olhando para trás, não me arrependo de ter seguido os conselhos e os ensinamentos de quem me acolheu de coração aberto.',
  },
  {
    author: 'Marta Silva',
    testimony: `Nesses anos em que frequênto e trabalho no Terreiro de Umbanda Vó Rita das Almas, aprendi muita coisa que transformou minha vida e a forma de ver as coisas. Eu era um furacão de sentimentos e rancores que juntei ao longo da minha vida. Com a agressividade, orgulho e falta de tantas coisas. Aprendi tanta coisa maravilhosa, e com a disciplina do terreiro aprendi a amenizar tudo isso. Hoje mais calma, procuro entender as coisas antes da revolta. Tudo a seu tempo... Tudo se transforma... E a caridade é a nossa  meta e responsabilidade no dia a dia. Eu tenho uma imensa gratidão pela ajuda em minha vida física e espiritual. Minha meta é se desenvolver cada dia mais.\nAxé 🙏`,
    highlight: 'Nesses anos que frequento e trabalho no Terreiro de Umbanda Vó Rita das Almas, aprendi muita coisa que transformou minha vida e a forma de ver as coisas.',
  },
  {
    author: 'Haddaway Lithely de Lima',
    testimony: `Minha jornada no Terreiro Vó Rita das Almas tem sido profundamente transformadora. Não apenas em minha jornada espiritual, mas também na minha jornada pessoal. Cada momento que tenho nesta casa é uma oportunidade única de crescimento, onde a sabedoria se manifesta de várias formas, guiando-me em direção à evolução.\n
Participar desta casa não só fortalece a minha conexão com o oculto, mas também me ensina a ser uma pessoa melhor a cada instante, fazendo-me ver onde erro e acerto, com mais compreensão e paz.\n
Agradeço sempre, a Querida Vó Rita das Almas, aos Guardiões do terreiro, ao querido Pai Noé e aos guias que assim me intuem no bom caminhar, pela oportunidade de ser parte desta vivência.\n
O que antes era como uma árvore de raízes tortas e entrelaçadas, hoje se transforma em um tronco forte, sempre em lapidação, buscando a serenidade e o equilíbrio.\n
Com este pequeno testemunho, espero inspirar aqueles que buscam trilhar o caminho da harmonia e evolução.\n
Cada passo dado na luz da sabedoria nos torna mais íntegros e conectados com nossa verdadeira essência.`,
    highlight: 'Participar desta casa não só fortalece a minha conexão com o oculto, mas também me ensina a ser uma pessoa melhor a cada instante, fazendo-me ver onde erro e acerto, com mais compreensão e paz.'
  },
  {
    author: 'João Augusto',
    testimony: `Conheci o Terreiro de Umbanda Vó Rita das Almas, durante a festa de preto velho de 2023 e desde de o momento que passei pelas portas do terreiro senti uma paz uma tranquilidade gigante me senti em casa.\n
O terreiro vem me fazendo muito bem, sempre fui uma pessoa extremamente reclusa e fechada, e durante o período que estive na assistência e quando entrei para a corrente mediúnica da casa venho aprendendo que é necessário ser mais solto, ser alegre, pois a beleza está em cada pequeno momento da vida, a cada dia melhoro um pouco mais.\n
Os desafios existem e sempre vão existir, mas com fé no Pai maior, em Pai Oxalá junto com todos os queridos orixás, fé nos amados pretos(a) velhos(as) e todos os guias que nos assistem que vem nessa casa trazer suas sabedorias, seu axé, e fé em nós mesmo nenhum desafio é impossível de ser superado, e isso junto com muitas outras coisas venho aprendendo dentro dessa casa maravilhosa.\n
Só tenho a agradecer por tudo que venho vivendo e aprendendo dentro do Terreiro de Umbanda Vó Rita das Almas..`,
    highlight: 'Só tenho a agradecer por tudo que venho vivendo e aprendendo dentro do Terreiro de Umbanda Vó Rita das Almas.'
  },
  {
    author: 'Sandra Fukuoka',
    testimony: `O terreiro vó Rita das almas foi a casa que me acolheu, andei por vários terreiros ao longo da minha jornada e nenhum preencheu o que eu buscava, no terreiro vó Rita das almas encontrei a paz, luz, amor, paciência e respeito de que eu tanto precisava, hoje sou mais tranquila nas minhas atitudes, durmo bem, antes a insônia dominava minhas noites, aprendi a importância do perdão, a importância de ouvir e quando saber falar.\n
Todos os dias são de aprendizados basta que parta da gente a mudança que tanto procuramos, minha fé muitas vezes é colocada a prova, não é fácil, mas minha perseverança é maior.
Agradeço sempre a oportunidade de estar junto à família vó Rita das almas, ao Pai Noé de Xangô que com paciência tem me ajudado a galgar um degrau a mais nessa minha jornada! Axé.`,
    highlight: 'No terreiro vó Rita das almas encontrei a paz, luz, amor, paciência e respeito de que eu tanto precisava.'
  },
  {
    author: 'Sílvia Mariano',
    testimony: `Estou no terreiro desde 2013, quando cheguei estava passando por momentos difíceis na minha vida.\n
Hoje só tenho gratidão por fazer parte dessa família.\n
Uma casa de luz,dirigida pelo Pai Noé de Xango.\n
Um Pai que está sempre à disposição dos filhos e de todos aqueles que chegarem.\n
Tive muitas bênçãos e recebi a minha cura física e espiritual.\n
A mudança vem todos os dias e assim vamos evoluindo.\n
Eu só tenho gratidão.\n
Sua benção vó Rita das almas.\n
Gratidão Pai Noé de Xango.`,
    highlight: 'A mudança vem todos os dias e assim vamos evoluindo.',
  },
  
]);

function openTestimony(idx: number) {
  testimony.value = testimonials.value[idx];
  document.body.classList.add('show-testimony-modal');
}
</script>
<template>
  <div class="w-full flex flex-col">
    <div class="w-full">
      <span class="block uppercase my-4">{{ $t('TESTIMONIALS') }}</span>
      <span class="block text-2xl md:text-4xl my-2">{{ $t('WHAT_PEOPLE_SAY') }}</span>
    </div>

    <div class="w-full block relative mt-10">
      <ClientOnly>
        <swiper-container ref="containerRef" :navigation="true" :pagination="true" :autoplay="true" :speed="5000">
          <swiper-slide
            v-for="(testimonial, idx) in testimonials"
            :key="idx"
          >
          <div>
            <div class="flex flex-col justify-start items-center w-full h-full px-0 lg:px-24">
              <p class="my-2 text-lg block w-full whitespace-break-spaces">{{ testimonial.testimony }}</p>
              <div class="flex justify-end w-full">
                <button class="underline my-4 hover:font-bold" @click="() => openTestimony(idx)">Ler depoimento completo</button>
              </div>
              <div class="flex w-full">
                <span class="font-bold my-2">{{ testimonial.author }}</span>
              </div>
            </div>
          </div>
          </swiper-slide>
        </swiper-container>
      </ClientOnly>
    </div>

    <portal to="testimonials-dialog">
      <AboutTestimony :author="testimony.author" :testimony="testimony.testimony" :highlight="testimony.highlight"/> 
    </portal>

  </div>
</template>
<style lang="scss" scoped>
swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  width: 100%;

  p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6; /* Number of lines to show */
    overflow: hidden;
    text-overflow: ellipsis;
    height: 173px;
  }
}

swiper-container {
  width: 100%;
}

ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1.5rem;

  li {
    background-color: #fff;
    text-align: left;

    &::before {
      content: '‟';
      font-family: "fontello";
      display: block;
      position: relative;
      width: 100%;
      height: 44px;
      line-height: 1;
      font-size: 70px;
      font-weight: 400;
      text-align: left;
      margin-bottom: 20px;
    }
  }
}

// ---------------------------------------
// Responsive
// ---------------------------------------

@media screen and (max-width: 1279px) {
  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      min-width: 400px;
      flex: 1;
    }
  }
}
</style>